export default __webpack_public_path__ + "static/highlight-ifaward-f9c29dd872cfd567d8c53f06225c656a.png";